import { UserRole } from 'types';

/**
 * Role sets that gate palette commands / actions and the search fan-out. These
 * mirror the visibility rules in `organisms/Menu/MenuContainer` and
 * `router/AppRouter#getRoutesByRole` so the palette never surfaces a destination
 * the current operator has no route to.
 */
export const STUDENT_ROLES: UserRole[] = [
  UserRole.ADMIN,
  UserRole.ACCOUNTANT,
  UserRole.SALESMANAGER,
  UserRole.FINANCIER,
];

export const EDUCATION_ROLES: UserRole[] = [
  UserRole.ADMIN,
  UserRole.ACCOUNTANT,
  UserRole.SALESMANAGER,
  UserRole.HRMANAGER,
];

export const FINANCE_VIEW_ROLES: UserRole[] = [
  UserRole.ADMIN,
  UserRole.FINANCIER,
  UserRole.ACCOUNTANT,
  UserRole.SALESMANAGER,
];

export const FINANCE_EXPENSE_ROLES: UserRole[] = [
  UserRole.ADMIN,
  UserRole.FINANCIER,
  UserRole.ACCOUNTANT,
];

export const FINANCE_PLAN_ROLES: UserRole[] = [
  UserRole.ADMIN,
  UserRole.FINANCIER,
];

export const ADMIN_ROLES: UserRole[] = [UserRole.ADMIN];

export const ZOOM_ROLES: UserRole[] = [
  UserRole.ADMIN,
  UserRole.ACCOUNTANT,
  UserRole.METHODIST,
];

// Survey constructor (spec 0011) — same managers who build/attach surveys and
// see results; mirrors the `/surveys` route + menu gate.
export const SURVEY_ROLES: UserRole[] = [
  UserRole.ADMIN,
  UserRole.ACCOUNTANT,
  UserRole.METHODIST,
];

// Career centre (spec 0018) — mirrors the `/career-center` route gate and the
// menu leaf. Note it carries HRManager, unlike SURVEY_ROLES.
export const CAREER_ROLES: UserRole[] = [
  UserRole.ADMIN,
  UserRole.ACCOUNTANT,
  UserRole.HRMANAGER,
  UserRole.METHODIST,
];

/**
 * Со-финансирование (ТЗ 0024) — зеркало `DOFIN_READ_ROLES` на бэкенде.
 *
 * Совпадает по составу со `STUDENT_ROLES`, но объявлено отдельно намеренно:
 * это разные правила, и когда одно из них поменяется, менять придётся именно
 * его, а не оба сразу. FinanceManager (`FINANCIER`) входит сюда **только на
 * чтение** — записи бэкенд ему не даёт.
 */
export const DOFIN_ROLES: UserRole[] = [
  UserRole.ADMIN,
  UserRole.ACCOUNTANT,
  UserRole.SALESMANAGER,
  UserRole.FINANCIER,
];

export const PERFORMANCE_ROLES: UserRole[] = [
  UserRole.ADMIN,
  UserRole.ACCOUNTANT,
  UserRole.HRMANAGER,
];

/**
 * `true` when `allowed` is undefined (visible to any logged-in operator) or the
 * operator holds at least one of the allowed roles.
 */
export const visibleFor = (roles: UserRole[], allowed?: UserRole[]): boolean =>
  !allowed || roles.some((role) => allowed.includes(role));
